export function handlePlayerError(player, uiComponents, input) {
    let message = '';
    if (typeof input === 'string') {
        message = input;
    }
    console.error('Er is iets mis met het ophalen van de stream.', input);
    player.unload();
    if (uiComponents.controlBar)
        uiComponents.controlBar.hide();
    if (uiComponents.errorMessageOverlay == undefined)
        return;
    uiComponents.errorMessageOverlay.show();
    uiComponents.errorMessageOverlay.errorLabel.setText(message ?? 'De video kan niet worden geladen');
}
